import React, {useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const Section7 = ({url}) => {

const [active, setActive] = useState(null);

const faqs = [
  {
    q: "What is custom software development?",
    a: "Custom software development is the process of designing, building, and deploying software applications tailored specifically to a business’s unique requirements, processes, and goals. Unlike off-the-shelf solutions, custom software is built around how your business actually operates, making it more efficient, scalable, and aligned with your competitive advantage.",
  },
  {
    q: "What is the difference between custom software and off-the-shelf software?",
    a: "Off-the-shelf software is designed for a broad audience and often requires businesses to adapt their processes to fit the tool. Custom software is built around your specific workflows and requirements. While it may require a higher upfront investment, it typically delivers better long-term ROI through improved efficiency, scalability, and no vendor dependency.",
  },
  {
    q: "How long does a custom software development project take?",
    a: "Timelines depend on scope and complexity. A focused internal tool or web application can take 6 to 12 weeks, while a full-scale platform with complex integrations may take 3 to 6 months. A clear timeline is established during the scoping phase before development begins.",
  },
  {
    q: "What technologies does ExD Digital use for custom software development?",
    a: "We select technology based on your project’s requirements rather than a fixed stack. Common technologies include React, Node.js, Python, .NET, Java, Flutter, and AWS. The final tech stack is chosen during the scoping phase based on scalability, performance, and long-term maintainability.",
  },
  {
    q: "How much does custom software development cost?",
    a: "Cost depends on scope, complexity, integrations, and timeline. We provide full cost transparency during the scoping phase, including a detailed breakdown before any contract is signed, so there are no surprises.",
  },
  {
    q: "Who owns the code after the project is completed?",
    a: "You do. All code, architecture, documentation, and intellectual property belong entirely to you after final payment. There are no licensing fees, no restrictions, and no dependency on us to use or modify your software.",
  },
  {
    q: "What industries does ExD Digital build software for?",
    a: "We have delivered custom software across fintech, healthcare, logistics, e-commerce, SaaS, and professional services. Our cross-industry experience allows us to apply proven solutions and patterns to new business challenges.",
  },
  {
    q: "What happens after the discovery call?",
    a: "After the discovery call, we prepare a detailed scoping document outlining the solution, technology approach, timeline, and cost. You review everything with full transparency before deciding whether to proceed. There is no obligation to move forward.",
  },
  {
    q: "Do you offer post-launch support and maintenance?",
    a: "Yes. We offer structured post-launch support and iteration packages. Your business evolves, and your software should evolve with it. We help maintain, improve, and scale your solution over time.",
  },
  {
    q: "What makes a good custom software development company?",
    a: "A strong partner provides transparent scoping, clear pricing, flexible engagement models, and a proven delivery track record. Just as important, they build systems you can maintain independently without long-term dependency.",
  },
  {
    q: "How do I know if my business needs custom software?",
    a: "You likely need custom software if your team relies on manual workarounds, your current tools cannot scale with your growth, or your competitive advantage depends on capabilities that off-the-shelf tools cannot provide.",
  },
  {
    q: "What makes ExD Digital different from other software development companies?",
    a: "We focus on full transparency before any commitment, iterative development with regular client feedback, and complete IP ownership for every project. Our goal is to deliver software that solves real problems and remains maintainable long after delivery.",
  },
  {
    q: "Can you integrate custom software with our existing systems?",
    a: "Yes. Integration is a core part of most projects we deliver. We build APIs, middleware, and data pipelines to connect your new software with existing systems such as CRMs, ERPs, payment gateways, and other business tools.",
  },
];

  return (

    <section className="home-section-7">
       {/* FAQ */}
        <div className="faq-section">
        <div className="container">

            <h2 className="text-center">Frequently Asked Questions</h2>

            <div className="faq-list">
            {faqs.map((item, i) => (
                <div
                key={i}
                className={`faq-item ${active === i ? "active" : ""}`}
                onClick={() => setActive(active === i ? null : i)}
                >
                <div className="faq-question">
                    <span>{item.q}</span>
                    <FontAwesomeIcon icon={faChevronDown} />
                </div>

                <div className="faq-answer">
                    {item.a}
                </div>
                </div>
            ))}
            </div>

        </div>
        </div>

        {/* CTA */}
        {/* <div className="cta-section">
        <div className="container">
            <div className="cta-box text-center">

            <h2>Now Hire the Right Employees with <br/> AI Power, not ManPower</h2>

            <button className="btn btn-light">Lets Get Started</button>

            </div>
        </div>
        </div> */}
    </section>
  );
};

export default Section7;